// Module
var code = "<kform kid=\"$ctrl.kid\" create=\"$ctrl.create\" name=\"formName\" options=\"$ctrl.options\" on-cancel=\"$ctrl.cancel()\" on-before-submit=\"$ctrl.checkDuplicates(forms, files)\" on-submit=\"$ctrl.submit(itemKid)\"></kform> ";
// Exports
export default code;